export default "__VITE_ASSET__eb82ba35__"